if (!customElements.get("footer-details")) {
  class FooterDetails extends AccordionDetails {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.openDefault = this.dataset.openDefault === 'true';

      if (FoxTheme.config.mqlTablet) {
        if (!this.openDefault) this.open = false;
      }

      document.addEventListener('matchTablet', () => {
        if (!this.openDefault) {
          this.open = false;
        } else {
          this.open = true;
        }
      });

      document.addEventListener('unmatchTablet', () => {
        this.open = true;
      });
    }
  }
  customElements.define('footer-details', FooterDetails, { extends: 'details' });
}

document.addEventListener('DOMContentLoaded', () => {
  const links = document.querySelectorAll('footer a.reversed-link[href*="?openModal="]');

  links.forEach(link => {
    link.addEventListener('click', (event) => {
      event.preventDefault();

      const href = link.getAttribute('href');      // "#?openModal=VCUv9e"
      const containerId = '#app-embed-container-'+ href.split('=')[1];      // "VCUv9e"
      const container = document.querySelector(containerId);
      console.log(containerId, container);


      container.classList.add('show-modal');

    });
  });
});
